import { RouteMatcher } from './route-matcher'
import type { AppRouteRouteDefinition } from '../route-definitions/app-route-route-definition'

export class AppRouteRouteMatcher extends RouteMatcher<AppRouteRouteDefinition> {}
